function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSetting = function SvgSetting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "transparent"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 21630"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17729",
    d: "M9.715 4.207a1.58 1.58 0 0 1 3.071 0 1.58 1.58 0 0 0 2.359.977 1.581 1.581 0 0 1 2.173 2.172 1.58 1.58 0 0 0 .976 2.358 1.58 1.58 0 0 1 0 3.071 1.58 1.58 0 0 0-.977 2.359 1.581 1.581 0 0 1-2.173 2.173 1.58 1.58 0 0 0-2.358.976 1.58 1.58 0 0 1-3.071 0 1.58 1.58 0 0 0-2.359-.977 1.581 1.581 0 0 1-2.172-2.173 1.58 1.58 0 0 0-.976-2.358 1.58 1.58 0 0 1 0-3.071 1.58 1.58 0 0 0 .977-2.359 1.581 1.581 0 0 1 2.172-2.171 1.58 1.58 0 0 0 2.358-.976Z",
    transform: "translate(.75 .75)",
    style: {
      strokeWidth: 2,
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17730",
    d: "M14.522 11.761A2.761 2.761 0 1 1 11.761 9a2.761 2.761 0 0 1 2.761 2.761Z",
    transform: "translate(.239 .239)",
    style: {
      strokeWidth: "1.5px",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
};

export default SvgSetting;